import styled from '@emotion/styled';
import { createElement, FC, useState } from 'react';

import { ProjectDetailsForShowFragment } from '../../../../generated/graphql';
import { SingleAssignmentFragment } from '../../../../generated/graphql_offer';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import BatchDownloadButton, { ConfirmationDialog } from '../BatchDownloadButton';

interface Props {
  project: Pick<ProjectDetailsForShowFragment, 'id' | 'projectType'>;
  offer: {
    rewardQuota: number;
    assignments: SingleAssignmentFragment[];
  };
  downloadAssets: any;
}

const ProjectDeliverablesActions: FC<Props> = ({ project, offer, downloadAssets }) => {
  const [downloadLoading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const downloadableAssignments = offer.assignments.filter((a) => a.status == 'COMPLETED' || a.status == 'ASSIGNED');
  const onClickBatchDonwloadButton = async (projectId: string) => {
    await downloadAssets({
      buckets: [],
      files: [],
      projects: [projectId],
    });
  };

  if (downloadableAssignments.length > 0) {
    return (
      <ActionsBar>
        <ButtonWithIconContainer>
          <BatchDownloadButton
            label="show_project_page.actions.download_all"
            tooltip={
              project.projectType.version <= 1
                ? 'show_project_page.download_all.tooltip.unpublished_project_type'
                : !(downloadableAssignments.length > 0)
                ? 'show_project_page.download_all.tooltip.desabled'
                : 'project_basic_setting_detail.assets.download_all.tooltip.desabled'
            }
            onClick={async () => {
              if (offer.rewardQuota == downloadableAssignments.length) {
                setLoading(true);
                await onClickBatchDonwloadButton(project.id);
                setTimeout(() => {
                  setLoading(false);
                }, 5 * 60 * 1000);
              } else {
                setOpenDialog(true);
              }
            }}
            disabled={downloadLoading}
            align="left"
          />
        </ButtonWithIconContainer>
        <ConfirmationDialog
          open={openDialog}
          onClickCancelButton={() => setOpenDialog(false)}
          onRequestClose={() => setOpenDialog(false)}
          onClick={async () => {
            await onClickBatchDonwloadButton(project.id);
            setOpenDialog(false);
          }}
        />
      </ActionsBar>
    );
  } else {
    return null;
  }
};

const ActionsBar = styled('div')({
  marginBottom: SPACING_REGULAR,
});

const ButtonWithIconContainer = styled('div')({
  display: 'flex',
  paddingRight: SPACING_UNIT,
  paddingBottom: SPACING_UNIT,
});

export default ProjectDeliverablesActions;
